export enum CareType {
  /**
   * Vollzeitpflege
   */
  FULL_TIME = 'FULL_TIME',
  /**
   * Kurzzeitpflege
   */
  SHORT_TERM = 'SHORT_TERM',
  /**
   * Kurzzeitpflege ohne §43b
   */
  SHORT_TERM_WITHOUT_SURCHARGE_43B = 'SHORT_TERM_WITHOUT_SURCHARGE_43B',
  /**
   * Verhinderungspflege
   */
  SUBSTITUTE = 'SUBSTITUTE',
}
